<template>
  <div class="container">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="点名课次" name="rollCallRecord">
          <rollCallList />
        </el-tab-pane>
        <el-tab-pane label="点名学员" name="rollCallStudentList">
          <rollCallStudentList :order-info="orderInfo"> </rollCallStudentList>
        </el-tab-pane>
        <el-tab-pane label="超时未点" name="timeoutNotPointList">
          <timeoutNotPointList />
        </el-tab-pane>
        <el-tab-pane
          label="补课管理"
          name="makeupList"
          v-if="showMakeUpLessons"
        >
          <makeUpLessons />
        </el-tab-pane>
        <el-tab-pane label="请假申请" name="leaveApplication">
          <leaveApplication />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script lane="ts">
import leaveApplication from "../leaveApplication/index.vue";
import rollCallList from "../rollCallList/index.vue";
import rollCallStudentList from "../rollCallStudentList/index.vue";
import timeoutNotPointList from "../timeoutNotPointList/index.vue";
import makeUpLessons from "../makeUpLessons/index.vue";
import { PageModule } from "@/store/module/page";
import { staffCheckApi } from "@/api/makeUpLessons";
import { number } from "echarts/core";
export default {
  name: "rollCallRecord",
  components: {
    leaveApplication,
    rollCallList,
    rollCallStudentList,
    timeoutNotPointList,
    makeUpLessons,
  },
  data() {
    return {
      activeName: "rollCallRecord",
      showDetails: false,
      leaveAppDetails: false,
      showDetailsId: "",
      leaveAppliId: "",
      showMakeUpLessons: false,
      orderInfo: {}, //订单详情过来的信息
    };
  },
  created() {
    staffCheckApi({
      api_path: ["/api/v1/class/lesson/repair/list"],
    }).then((res) => {
      if (res.error_code === 0) {
        this.showMakeUpLessons = res.data["/api/v1/class/lesson/repair/list"]
          ? true
          : false;
      }
    });
    if (this.$route.query.tab) {
      this.activeName = this.$route.query.tab;
    } else {
      const cache = PageModule.pageInfo.rollCallRecordList;
      if (cache.tab) {
        this.activeName = cache.tab;
      } else {
        this.activeName = "rollCallRecord";
        PageModule.SET_PAGE_INFO({
          name: "rollCallRecordList",
          key: "tab",
          value: "rollCallRecord",
        });
      }
    }
    if (this.$route.query.tid && this.$route.query.name) {
      this.activeName = "rollCallStudentList";
    }
    if (this.$route.query.tid && this.$route.query.route_type === "3") {
      this.activeName = "rollCallRecord";
    }
    if (this.$route.query.tid && this.$route.query.route_type === "4") {
      this.activeName = "rollCallStudentList";
    }
    if (this.$route.query.from === "order") {
      this.orderInfo = {
        s_name: this.$route.query.s_name,
        c_id: Number(this.$route.query.c_id),
        ex_type: Number(this.$route.query.ex_type),
      };
      this.activeName = "rollCallStudentList";
    }
  },
  methods: {
    handleClick(tab) {
      PageModule.SET_PAGE_INFO({
        name: "rollCallRecordList",
        key: "tab",
        value: tab.name,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  height: calc(100% - 34px);
  background: #fff;
}
.el-tabs__item.is-top.is-active {
  color: #07d1aa !important;
}
</style>
